import { render, staticRenderFns } from "./HoraryForm.vue?vue&type=template&id=5b56c396&scoped=true&"
import script from "./HoraryForm.vue?vue&type=script&lang=js&"
export * from "./HoraryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56c396",
  null
  
)

export default component.exports